import { render, staticRenderFns } from "./UiVueSelect.vue?vue&type=template&id=37715e6f"
import script from "./UiVueSelect.vue?vue&type=script&lang=js"
export * from "./UiVueSelect.vue?vue&type=script&lang=js"
import style0 from "./UiVueSelect.vue?vue&type=style&index=0&id=37715e6f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports